module.exports = __webpack_public_path__ + "img/heart-with-white-bg.5b61ea15.png";